// extracted by mini-css-extract-plugin
export var imageAndText = "styles-module--imageAndText--lSQvJ";